var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTdhLightMode = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 64,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M31.946 0c4.21-.02 7.597 3.403 7.618 7.611.02 4.208-3.394 7.624-7.603 7.645 9.25-.047 16.748 7.414 16.795 16.663.047 9.248-7.467 16.778-16.717 16.825-4.209.022-7.603 3.37-7.603 7.645 0 4.274 3.463 7.633 7.672 7.61C49.777 63.91 64.089 49.518 64 31.852 63.91 14.187 49.615-.088 31.946 0Z",
  fill: "#00B5E2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M32.107 64c-4.209-.002-7.672-3.403-7.671-7.611 0-4.208 3.393-7.646 7.603-7.645-9.25 0-16.796-7.5-16.796-16.748 0-9.248 7.467-16.74 16.717-16.74 4.21-.001 7.603-3.337 7.603-7.645S36.155-.001 31.946 0C14.277 0 0 14.32 0 31.985 0 49.651 14.439 64 32.107 64Z",
  fill: "#351F65"
})));
export default SvgTdhLightMode;